"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/OutputFactory/type/OutputImage/index.js";
function OutputImage(_ref) {
  var field = _ref.field,
    object = _ref.object;
  var value = object[field];
  if (value && typeof value !== 'object') {
    return /*#__PURE__*/_react["default"].createElement("img", {
      style: {
        objectFit: "cover",
        width: "20px",
        height: "20px"
      },
      src: value,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7,
        columnNumber: 13
      }
    });
  }
  return null;
}
var _default = exports["default"] = OutputImage;